import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OrgUnit, OrgUnitCategory } from '@tran-monorepo/interfaces/applications';
import { CheckboxTreeViewSelectionComponent } from '../form/checkbox-tree-view-selection';

@Component({
    selector: 'tran-org-unit-selector',
    imports: [CheckboxTreeViewSelectionComponent],
    templateUrl: './org-unit-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgUnitSelectorComponent {
    public readonly control = input.required<FormControl<OrgUnit[]>>();
    public readonly displayControl = input<FormControl<string[]>>();
    public readonly orgUnits = input<OrgUnit[]>([]);
    public readonly label = input.required<string>();
    public readonly readonly = input(false, { transform: booleanAttribute });
    public readonly submitted = input(false);

    protected readonly orgUnitItemId = (unit: OrgUnit): string => unit.id;
    protected readonly orgUnitItemLabel = (unit: OrgUnit): string => unit.abbreviation;
    protected readonly orgUnitCategory = (unit: OrgUnit): OrgUnitCategory | null => unit.category ?? null;
}
